<div class="quote-flow-stepper">
  <p-stepper [value]="activeStep()" [linear]="true">

    <!-- Header only earns its place when there is more than one step to move between. -->
    @if (showStepHeader()) {
      <p-step-list>
        @if (showCurrencyStep()) {
          <p-step [value]="currencyStepIndex()">
            <span class="yllw-step__label">{{ 'CURRENCY_WARNING.TITLE' | translate }}</span>
          </p-step>
        }
        @if (showCreditStep()) {
          <p-step [value]="creditStepIndex()">
            <span class="yllw-step__label">{{ 'QUOTE.CREDIT_CHECK.DIALOG_TITLE' | translate }}</span>
          </p-step>
        }
        <p-step [value]="sendStepIndex()">
          <span class="yllw-step__label">{{ 'SEND_QUOTE.TITLE' | translate }}</span>
        </p-step>
      </p-step-list>
    }

    <p-step-panels>
      @if (showCurrencyStep()) {
        <p-step-panel [value]="currencyStepIndex()">
          <ng-template #content>
            <app-currency-warning-dialog [embedded]="true" (resolved)="advanceFrom(currencyStepIndex())" />
          </ng-template>
        </p-step-panel>
      }

      @if (showCreditStep()) {
        <p-step-panel [value]="creditStepIndex()">
          <ng-template #content>
            <app-credit-check-step
              stepMode="send"
              (proceed)="advanceFrom(creditStepIndex())"
              (cancelled)="cancel()" />
          </ng-template>
        </p-step-panel>
      }

      <p-step-panel [value]="sendStepIndex()">
        <ng-template #content>
          <app-send-quote-dialog [embedded]="true" />

          <div class="quote-flow-stepper__footer">
            <p-button [label]="'ABORT' | translate" [text]="true" (onClick)="cancel()" />
            <p-button
              [label]="'QUOTE.DETAIL.QUOTE_INFORMATION.SEND' | translate"
              [disabled]="!canSend()"
              (onClick)="submit()" />
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
</div>
